// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2PFV3","question":"Question_question__3hoGD","description":"Question_description__1J8s9"};